export enum HsdqCategoryName {
    crsd = 'CRSD',
    hypersomnolentie = 'Hypersomnolentie',
    insomnia = 'Insomnia',
    parasomnia = 'Parasomnia',
    rlsLms = 'RLS-LMS',
    sbd = 'SBD',
}
